(function () {
  'use strict';

  var frame = 0;
  var observer = null;
  var EXCLUDED_TAGS = ['LINK', 'SCRIPT', 'STYLE', 'TEMPLATE'];

  function hasVisibleBackground(style) {
    return style.backgroundImage !== 'none' || !/^rgba?\(0(?:,?\s*0){2}(?:,?\s*0)?\)$/.test(style.backgroundColor);
  }

  function meaningfulRoot(owner) {
    var children = Array.prototype.filter.call(owner.children || [], function (element) {
      return EXCLUDED_TAGS.indexOf(element.tagName) === -1 &&
        !element.classList.contains('section-background');
    });
    return children.find(function (element) {
      return element.matches('section, article, main, [data-article-section]');
    }) || children[0] || owner;
  }

  function backgroundStyle(owner, root) {
    var rootStyle = window.getComputedStyle(root);
    return hasVisibleBackground(rootStyle) ? rootStyle : window.getComputedStyle(owner);
  }

  function signature(style) {
    return [style.backgroundColor, style.backgroundImage].join('|');
  }

  function preservesSeam(root) {
    if (root.hasAttribute('data-bn-article-seam-preserve')) return true;
    return Array.prototype.some.call(root.classList || [], function (token) {
      return /(?:^|[-_])(hero|quote|pullquote|cta|conversion)(?:$|[-_])/.test(token.toLowerCase());
    });
  }

  function clear(layout) {
    Array.prototype.forEach.call(
      layout.querySelectorAll('[data-bn-article-same-before], [data-bn-article-same-after]'),
      function (element) {
        element.removeAttribute('data-bn-article-same-before');
        element.removeAttribute('data-bn-article-same-after');
      }
    );
  }

  function mark(layout) {
    clear(layout);
    if (layout.classList.contains('bn-article-layout--single')) return;
    var content = layout.querySelector(':scope > .bn-article-layout__content');
    if (!content) return;

    var bands = Array.prototype.map.call(content.children, function (owner) {
      var root = meaningfulRoot(owner);
      var style = backgroundStyle(owner, root);
      return {
        root: root,
        signature: signature(style),
        preserve: preservesSeam(root)
      };
    });

    for (var index = 1; index < bands.length; index += 1) {
      var previous = bands[index - 1];
      var current = bands[index];
      if (previous.preserve || current.preserve || previous.signature !== current.signature) continue;
      previous.root.setAttribute('data-bn-article-same-after', '');
      current.root.setAttribute('data-bn-article-same-before', '');
    }
  }

  function scan() {
    frame = 0;
    Array.prototype.forEach.call(
      document.querySelectorAll('.bn-article-layout.bn-article-layout--ready'),
      mark
    );
  }

  function schedule() {
    if (frame) window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(function () {
      frame = window.requestAnimationFrame(scan);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);

  if ('MutationObserver' in window) {
    observer = new MutationObserver(function (records) {
      if (records.some(function (record) { return record.type === 'childList'; })) schedule();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
